import {AfterViewInit, Component, ElementRef, Input, ViewChild} from "@angular/core";
import _ from "lodash";
import {ChartPropertiesService} from "../../services/chart-properties-service";
import * as Highcharts from 'highcharts';
import Highcharts3D from 'highcharts/highcharts-3d';

Highcharts3D(Highcharts);

@Component({
    selector: "chart-preview",
    templateUrl: "./chart-preview.component.html",
    styleUrls: ["./chart-preview.component.scss"]
})
export class ChartTemplatePreviewComponent implements AfterViewInit {
    @ViewChild("chartPreviewDiv") chartPreviewDiv!: ElementRef<HTMLElement>;

    _chartProject: any;
    viewInitialized: boolean = false;
    @Input() height: any;
    @Input() width: any;
    @Input()
    set chartProject(project) {
        this._chartProject = project;
        if (this.viewInitialized) {
            this.loadChartPreview();
        }
    }
    get chartProject() {
        return this._chartProject;
    }

    chart: any;

    constructor(private chartProperties: ChartPropertiesService) {
    }

    ngAfterViewInit(): void {
        this.viewInitialized = true;
        this.loadChartPreview();
    }

    private loadChartPreview() {
        if (!this.chartPreviewDiv) {
            return;
        }

        const project = this.parseChartProject(this.chartProject);
        if (!project) {
            return;
        }

        const chartOptions = project.options || {};
        const chartTemplate = project.template || {};
        const options = _.merge(_.cloneDeep(chartOptions), _.cloneDeep(chartTemplate));

        // execute customCode if present (apply labelFormatter, chart events, plotOptions overrides, etc) before rendering
        const customCode = project.customCode;
        if (customCode && customCode.trim().length > 0) {
            try {
                const fn = new Function('options', 'Highcharts', customCode);
                fn(options, Highcharts);
            } catch (e) {
                console.warn('customCode execution failed:', e);
            }
        }

        // this is to fix default existent templates without colors
        if (!options.colors || options.colors.length === 0) {
            delete options.colors;
        }

        // remove null values that cause SVG attribute errors (e.g., borderRadius: null)
        this.chartProperties.removeNullValues(options);

        this.chartProperties.setPreviewOptions(options, this.height, this.width);
        this.chartProperties.simplifyView(options);

        if (this.chart) {
            this.chart.destroy();
        }

        this.chart = Highcharts.chart(this.chartPreviewDiv.nativeElement, options as Highcharts.Options);
    }

    private parseChartProject(chartProject: any): any {
        if (!chartProject) return null;

        try {
            if (typeof chartProject === "string" || chartProject instanceof String) {
                let jsonStr = chartProject.toString().trim();
                // detect base64 encoded string (doesn't start with '{')
                if (!jsonStr.startsWith("{")) {
                    jsonStr = atob(jsonStr);
                }
                return JSON.parse(jsonStr);
            }
            return chartProject;
        } catch (e) {
            console.error("Error parsing chart project:", e);
            return null;
        }
    }

}
